import { useEffect, useState } from "react"

const useStickyFilter = (isCeil: boolean) => {
  // 是否筛选器吸顶
  const [isSticky, setIsSticky] = useState(false)
  // 滚动高度
  const [scrollTop, setScrollTop] = useState(0)
  // 吸顶时是否展开状态
  const [isExpand, setIsExpand] = useState(false)

  if (!isCeil) return { isSticky, scrollTop, isExpand, setIsExpand }

  // 监听滚动吸顶
  useEffect(() => {
    const scorllBody = document.getElementsByClassName('dbd-scroll-body')[0]
    scorllBody && scorllBody.addEventListener('scroll', scrollFunc)
    return () => scorllBody && scorllBody.removeEventListener("scroll", scrollFunc);
  }, [])

  const scrollFunc = (e: any) => {
    const scorllBody = e.target
    setScrollTop(scorllBody?.scrollTop)
    if (scorllBody?.scrollTop > 300) {
      setIsSticky(true)
    } else {
      setIsSticky(false)
    }
  }

  return { isSticky, scrollTop, isExpand, setIsExpand }
}

export default useStickyFilter